import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2';
import VueMask from 'v-mask'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueYoutube from 'vue-youtube'
import vco from "v-click-outside"

import router from './router'
import store from '@/state/store'
import i18n from './i18n'
import { setupGlobalErrorHandlers, globalErrorHandler } from '@/utils/errorHandler'
import ErrorHandlerPlugin from '@/plugins/errorHandler'

import "@/assets/scss/app.scss";
// Import Font Awesome
import '@fortawesome/fontawesome-free/css/all.css'

Vue.config.productionTip = false
Vue.use(VueYoutube)
Vue.use(BootstrapVue)
Vue.use(vco)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2);
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(Vuelidate);
Vue.use(ErrorHandlerPlugin);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)

// Set up global error handlers with store
setupGlobalErrorHandlers(Vue, router, store)

// Add global error handler mixin to all components
Vue.mixin(globalErrorHandler)

// Vue error handler for component errors
Vue.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error Handler:', err, info)
  
  // Store error in Vuex store
  store.dispatch('error/captureError', { error: err, errorInfo: info })
  
  // Navigate to global error page
  router.push({
    name: 'ErrorBoundary',
    query: {
      timestamp: Date.now()
    }
  }).catch(() => {
    // Fallback if routing fails - styled to match the app
    const fallbackError = document.createElement('div');
    fallbackError.innerHTML = `
      <div style="
        position: fixed; top: 0; left: 0; width: 100%; height: 100%;
        background: rgba(0,0,0,0.7); display: flex; justify-content: center;
        align-items: center; z-index: 9999; 
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        backdrop-filter: blur(4px);
      ">
        <div style="
          background: white; padding: 3rem 2.5rem; border-radius: 12px; text-align: center;
          max-width: 450px; margin: 1rem; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
          border: 1px solid #e5e7eb;
        ">
          <div style="
            width: 64px; height: 64px; background: #fef2f2; border-radius: 50%;
            display: flex; align-items: center; justify-content: center; margin: 0 auto 1.5rem;
          ">
            <svg style="width: 32px; height: 32px; color: #dc2626;" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM13 17h-2v-2h2v2zm0-4h-2V7h2v6z"/>
            </svg>
          </div>
          <h2 style="color: #1f2937; font-size: 1.5rem; font-weight: 600; margin-bottom: 0.75rem; line-height: 1.4;">
            Oops! Something went wrong
          </h2>
          <p style="color: #6b7280; font-size: 1rem; margin-bottom: 2rem; line-height: 1.5;">
            It's our fault, not yours. Please try refreshing the page.
          </p>
          <button onclick="window.location.reload()" style="
            background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%); color: white; border: none; 
            padding: 0.875rem 2rem; border-radius: 8px; cursor: pointer; font-size: 1rem; font-weight: 500;
            transition: all 0.2s ease; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); min-width: 140px;
          ">Reload Page</button>
          <div style="margin-top: 1.5rem; padding-top: 1.5rem; border-top: 1px solid #e5e7eb;">
            <p style="color: #9ca3af; font-size: 0.875rem; margin: 0;">© Wiremit</p>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(fallbackError);
  })
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

 
